/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestTransferDto
 */
export interface RequestTransferDto {
    /**
     * Amount to transfer in dollars (e.g., 100.50 for $100.50)
     * @type {number}
     * @memberof RequestTransferDto
     */
    amountInDollars: number;
    /**
     * Optional description for the transfer
     * @type {string}
     * @memberof RequestTransferDto
     */
    description?: string;
}

/**
 * Check if a given object implements the RequestTransferDto interface.
 */
export function instanceOfRequestTransferDto(value: object): value is RequestTransferDto {
    if (!('amountInDollars' in value) || value['amountInDollars'] === undefined) return false;
    return true;
}

export function RequestTransferDtoFromJSON(json: any): RequestTransferDto {
    return RequestTransferDtoFromJSONTyped(json, false);
}

export function RequestTransferDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTransferDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amountInDollars': json['amountInDollars'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function RequestTransferDtoToJSON(json: any): RequestTransferDto {
    return RequestTransferDtoToJSONTyped(json, false);
}

export function RequestTransferDtoToJSONTyped(value?: RequestTransferDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountInDollars': value['amountInDollars'],
        'description': value['description'],
    };
}

